<template>
  <footer
    class="task-modal-picker-footer"
    :class="{ 'is-page-sticky': sticky }"
  >
    <div
      class="task-modal-picker-footer__inner"
      :class="{ 'is-split': hasLeftSlot }"
    >
      <div v-if="hasLeftSlot" class="task-modal-picker-footer__left">
        <slot name="left" />
      </div>
      <div class="task-modal-picker-footer__right">
        <slot />
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'StickyFormFooter',
  props: {
    /**
     * Page layouts (e.g. Settings TaskForm) stick to the viewport bottom.
     * Modal pickers leave this false — the shell flexes the footer with margin-top: auto.
     */
    sticky: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasLeftSlot: function () {
      return !!this.$slots.left
    }
  }
}
</script>
